// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";
import MaskedInput from "react-text-mask";
import emailMask from "text-mask-addons/dist/emailMask";

type PropsType = {
  formElements: Object,
  translate: string => void,
  loginFormElementValueChange: (string, string) => void,
  loginFormSubmit: Object => void
};

type StateType = {};

class LoginForm extends Component<PropsType, StateType> {
  render() {
    const { formElements, translate, loginFormElementValueChange, loginFormSubmit } = this.props;
    return (
      <div>
        <div className="h-50px" />
        <div className="form-row text-center">
          <div className="form-group col-md-8 offset-2">
            <MaskedInput
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("LoginLocale.form.form_unit.username")}
              value={formElements.username}
              mask={emailMask}
              name="username"
              onChange={event => {
                loginFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <input
              className="form-control form-control-sm"
              type="password"
              placeholder={translate("LoginLocale.form.form_unit.password")}
              value={formElements.password}
              name="password"
              onChange={event => {
                loginFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <button
              className="btn btn-block btn-primary"
              onClick={() => {
                loginFormSubmit(formElements);
              }}
            >
              {translate("LoginLocale.form.form_unit.submit")}
            </button>
          </div>
        </div>
        <hr className="w-30" />
        <p className="text-center text-muted small-2">
          {translate("LoginLocale.form.register.content")}
          <Link to="/kayit-ol">{translate("LoginLocale.form.register.link")}</Link>
        </p>
      </div>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/Components/PublicAccountPages/Components/Login/LoginForm.js